import { render } from "./FilterCustomerPriorityLevel.vue?vue&type=template&id=6a097550"
import script from "./FilterCustomerPriorityLevel.vue?vue&type=script&lang=js"
export * from "./FilterCustomerPriorityLevel.vue?vue&type=script&lang=js"
script.render = render

export default script